export default {
    productList: [
        {
            id: 1,
            img: require("@a/images/panorama.png"),
            title: "全景实况导航",
            dec: "全景实况导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
        {
            id: 6,
            img: require("@a/images/realistic.png"),
            title: "实景卫星导航",
            dec: "实景卫星导航是一款使用全景实况技术为您提供导航的软件。它能够语音播报导航路线，根据您当前的位置实时引导到达目的地。",
            btnType: 2,//1 ios 2 android
            qrCodeShow: false,
            qrCodeUrl: ''
        },
    ]
}